import React, { createContext, useMemo, useState } from 'react';

export const TransactionCreateContext = createContext({
    contextState: {
        isCreatePanelVisible: false,
        setIsCreatePanelVisible: () => {},
    },
    contextAction: {},
    contextProps: {},
});

export function TransactionCreateProvider({
    // parent props
    children, setCurrentPage, ...props
}) {
    const [isCreatePanelVisible, setIsCreatePanelVisible] = useState(false);
    const [createTransactionType, setCreateTransactionType] = useState(null);
    const [multilineItems, setMultilineItems] = useState([]);
    const [isFadingOut, setIsFadingOut] = useState(false); // for animations only

    const addMultilineItem = item => setMultilineItems(prevItems => [...prevItems, item]);
    const deleteMultilineItem = rowKey => setMultilineItems(
        prevItems => prevItems.filter(i => i.rowKey !== rowKey),
    );
    const updateMultilineItem = item => setMultilineItems(
        prevItems => prevItems.map(i => {
            if (i.rowKey === item.rowKey)
                return {...i, ...item};
            return i;
        }),
    );

    const contextValues = useMemo(() => ({
        contextState: {
            isCreatePanelVisible,
            createTransactionType,

            // used for income/expenses PanelItems
            multilineItems,

            // used when panel is closed
            isFadingOut,
        },
        contextAction: {
            setIsCreatePanelVisible,
            setCreateTransactionType,

            // used for income/expenses PanelItems
            setMultilineItems,
            addMultilineItem,
            deleteMultilineItem,
            updateMultilineItem,

            // used when panel is closed
            setIsFadingOut,
        },
        contextProps: {
            setCurrentPage,
            ...props,
        },
    }), [
        isCreatePanelVisible, createTransactionType, multilineItems, isFadingOut,
        setCurrentPage,
        props,
    ]);

    return (
        <TransactionCreateContext.Provider
            value={contextValues}
        >
            {children}
        </TransactionCreateContext.Provider>
    );
}
